<template>
  <TableGroup
    table-title="Документы"
    modal-title="Создать документ"
    namespaced="pto/project/document"
    :rights-all="$store.getters.rightsPtoAll"
    :init-filter="initFilter"
    :add-to-post-data="initFilter"
    post-data-has-files
  >
    <template v-slot:beforeTable>
      <div class="page__row">
        <AppCheckbox
          title="Показать аннулированные"
          :checked="isShowAnnulled"
          @toggle-check="showAnnulled()"
        />
      </div>
    </template>

    <template v-slot:modalForm="props">
      <FormPtoProjectDocument
        :is-sending="props.isSendingRequest"
        @request="props.createSubmit"
        @cancel="props.closeModal"
      />
    </template>
  </TableGroup>
</template>

<script>
import AppCheckbox from '@/components/page/input/AppCheckbox.vue'
import FormPtoProjectDocument from '@/components/pto/form/FormPtoProjectDocument'
import TableGroup from '@/components/page/TableGroup'
import { MIXIN_PTO_ANNULLED } from '@/mixins/module/pto/project/mixinPTOAnnulled'

import { mapActions } from 'vuex'

export default {
  name: 'PtoProjectDocument',
  components: {
    FormPtoProjectDocument,
    AppCheckbox,
    TableGroup
  },
  mixins: [
    MIXIN_PTO_ANNULLED
  ],

  data: () => ({
    annulledQueryKey: 'status',
    namespaced: 'pto/project/document'
  }),

  async mounted () {
    await Promise.all([
      this.GETDocumentFileTypeList(),
      this.GETDocumentStatusList()
    ])
  },

  methods: {
    ...mapActions('handbook/pto', {
      GETDocumentFileTypeList: 'GETDocumentFileTypeList',
      GETDocumentStatusList: 'GETDocumentStatusList'
    })
  }
}
</script>
